import gql from 'graphql-tag';
import apolloClient from '../../../../../config/apolloClient';

const STATE_AND_COST_QUERY = gql`
    query fetchProviderLocation($providerId: String, $locationId: String) {
        providerLocation(providerId: $providerId, locationId: $locationId) {
            location {
                state
            }
            costPlanValue
        }
    }
`;

export default async function fetchCostPlanValue(
    providerMonolithId,
    locationMonolithId
) {
    if (!providerMonolithId || !locationMonolithId) {
        return null;
    }

    const provLocOptions = {
        variables: {
            providerId: providerMonolithId,
            locationId: locationMonolithId,
        },
        query: STATE_AND_COST_QUERY,
    };

    try {
        const res = await apolloClient.query(provLocOptions);
        return res.data.providerLocation;
    } catch (err) {
        return null;
    }
}
